import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import LoadingScreen from '../common/LoadingScreen';

interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const { isAuthenticated, authLoading } = useAuthContext();
  const location = useLocation();

  // If auth state is still loading, show loading screen
  if (authLoading) {
    return <LoadingScreen />;
  }

  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    // Store the current path for redirect after login
    localStorage.setItem('redirectPath', location.pathname);
    return <Navigate to="/" replace />;
  }

  // If authenticated, render the requested element
  return <>{element}</>;
};

export default ProtectedRoute;
